module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/logo_banner/image 022-2b6f6a94ab55b5da327763bbec68bbe8.png";